module.exports = __webpack_public_path__ + "static/React-04acbf1bb381cf5f31e4d53a436297c7.jpg";